// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__T1kg9","inputWrap":"styles_inputWrap___Ms1w","input":"styles_input__3FxpU"};